import { useState } from "react";

// Componentes
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonSpinner from "../../../../../components/Buttons/ButtonSpinner";

// Services
import { createEventsXGroups } from "../../../../../utils/services/portalBoticario";

const TAG_OPTIONS = [
  { value: "base", label: "Base de Cadastros" },
  { value: "registered", label: "Cadastrados" },
];

export const ModalNewEventsXGroups = ({
  isOpen,
  toggle,
  jwt,
  refetch,
  defaultEventId,
}) => {
  // state do formulário
  const [formData, setFormData] = useState({
    eventId: defaultEventId || "",
    groupId: "",
    tag: "",
  });

  // state de controle
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.eventId.trim()) newErrors.eventId = "Campo obrigatório";
    if (!formData.groupId.trim()) newErrors.groupId = "Campo obrigatório";
    if (!formData.tag) newErrors.tag = "Campo obrigatório";
    return newErrors;
  };

  // traduz mensagem de erro da API para texto amigável
  const getApiErrorMessage = (message) => {
    const map = {
      DUPLICATE_GROUP: "Este grupo já está vinculado a um evento.",
      GROUP_ALREADY_EXISTS: "Este grupo já está vinculado a um evento.",
      EVENT_ALREADY_HAS_GROUP: "Este evento já possui um grupo vinculado.",
      DUPLICATE_EVENT_GROUP: "Já existe um vínculo entre este evento e grupo.",
    };
    return (
      map[message] ||
      message ||
      "Erro ao conectar com o servidor. Verifique sua conexão."
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    try {
      await createEventsXGroups(
        {
          eventId: formData.eventId.trim(),
          groupId: formData.groupId.trim(),
          tag: formData.tag,
        },
        jwt
      );
      refetch();
      setIsShowSuccess(true);
    } catch (error) {
      const message = error.response?.data?.message;
      setErrors({ api: getApiErrorMessage(message) });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} centered autoFocus>
      <ModalHeader toggle={toggle}>Novo Vínculo Evento x Grupo</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">ID do Evento *</label>
              <input
                className="form-control"
                type="text"
                name="eventId"
                value={formData.eventId}
                onChange={handleChange}
                placeholder="UUID do evento"
              />
              {errors.eventId && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.eventId}
                </span>
              )}
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">ID do Grupo *</label>
              <input
                className="form-control"
                type="text"
                name="groupId"
                value={formData.groupId}
                onChange={handleChange}
                placeholder="UUID do grupo"
              />
              {errors.groupId && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.groupId}
                </span>
              )}
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">Tag *</label>
              <select
                className="form-control"
                name="tag"
                value={formData.tag}
                onChange={handleChange}
              >
                <option value="">Selecione...</option>
                {TAG_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {errors.tag && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.tag}
                </span>
              )}
            </Col>
          </Row>

          {errors.api && (
            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <span className="text-danger" style={{ fontSize: 13 }}>
                  {errors.api}
                </span>
              </Col>
            </Row>
          )}

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Button
                color="danger"
                style={{ width: 80, marginRight: 10 }}
                onClick={toggle}
                disabled={isLoading}
              >
                Fechar
              </Button>
              <ButtonSpinner
                title="Salvar"
                type="submit"
                isLoading={isLoading}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>

      {isShowSuccess && (
        <SweetAlert
          title="Criado"
          success
          onConfirm={() => {
            setIsShowSuccess(false);
            toggle();
          }}
        >
          Vínculo criado com sucesso!
        </SweetAlert>
      )}
    </Modal>
  );
};
